import {IProcessFlowCallToAction} from "~/interfaces/processFlowInterfaces"
import ProcessFlowMappedVariable from "~/models/processFlows/steps/processFlowMappedVariable"
import {CallToActionType} from "~/enums/processFlows/callToActionType"
import {RelationType} from "~/models/relationType"
import ProcessFlowBuilderModel from "~/models/tracked/processFlowBuilderModel"
import Guid from "~/helpers/guid"
import IRepo from "~/interfaces/repo"
import Repo from "~/state/modules/repo"

export default class ProcessFlowCallToAction extends ProcessFlowBuilderModel implements IProcessFlowCallToAction {
  action_type: CallToActionType
  button_label: string

  private readonly _buttonLabelRequired: boolean
  get buttonLabelRequired(): boolean {
    return this._buttonLabelRequired
  }

  /**
   * override in subclasses
   */
  get isValid(): boolean {
    throw new Error("Method not implemented.")
  }

  constructor(protected _rootName: string, options: any = {}) {
    super()
    this._nameInParent = _rootName
    this.defineClientId(options.client_id);
    this.defineProperty('action_type', options.actionType)
    this._buttonLabelRequired = options.buttonLabelRequired
  }

  // ******************** RELATIONS AND REPOS ******************** //
  static repo: IRepo<ProcessFlowCallToAction> = new Repo<ProcessFlowCallToAction>('processFlowCallToActions', ProcessFlowCallToAction, {});
  repo: IRepo<this>;

  addToRepo(): void {
    ProcessFlowCallToAction.repo.add(this)
  }

  get rootName(): string {
    return this._nameInParent;
  }

  get isCollectionRoot(): boolean {
    return false;
  }

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    return {
      variable_reference: {
        type: ProcessFlowMappedVariable,
        relationType: RelationType.singleObject,
      },
    }
  }

  createEmbeddedObject = {
    variable_reference(parent: IProcessFlowCallToAction, json): ProcessFlowMappedVariable {
      return ProcessFlowMappedVariable.repo.findOrCreateWith(json.client_id, 'variable_reference');
    },
  }

  createVariableReference(): ProcessFlowMappedVariable {
    const mappedVariable = this.createEmbeddedObject.variable_reference(this, { client_id: Guid.create() })
    mappedVariable.attachToParent(this)
    return mappedVariable
  }

  // ******************** RELATIONS AND REPOS END ******************** //

  /**
   * Called when variableReference (i.e. MappedVariable) for call to action changes
   * implement in subclasses
   */
  resetAfterVariableReferenceChange(): void {
  }
}